import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';

import { MediaImageModel } from '@modules/media/models/media-image.model';

import { ImageComponent } from '../../media/image/image.component';

@Component({
  selector: 'mb-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContactCardComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);

  @Input() fullname?: string;
  @Input() initials?: string;
  @Input() position?: string;
  @Input() image?: MediaImageModel;
  @Input() email?: string;
  @Input() phone?: string;
  @Input() dark = false;
  @Input() x?: string;
  @Input() linkedIn?: string;

  public emailFirstPart: string = '';
  public emailSecondPart: string = '';
  public positionHTML!: SafeHtml;

  ngOnInit(): void {
    if (this.email) {
      this.emailFirstPart = this.email.split('@')[0] + '@';
      this.emailSecondPart = this.email.split('@')[1];
    }

    this.positionHTML = this.position
      ? this.sanitizer.bypassSecurityTrustHtml(
          this.position.replaceAll('Mercedes-Benz', '<span style="white-space: nowrap;">Mercedes-Benz</span>')
        )
      : '';
  }
}
